import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.land-documents-index-page', () => {
  void import('./internal/land-documents-index-page').then(({ default: Component }) => Component());
});
